import script from "./ManageActivityWarehouse.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageActivityWarehouse.vue?vue&type=script&setup=true&lang=js"

import "./ManageActivityWarehouse.vue?vue&type=style&index=0&id=4ab4b586&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ab4b586"]])

export default __exports__